import { Pipe, PipeTransform } from "@angular/core";
import { CurrencyNoteType } from "../api/api";

/** Fallback note name; prefer the backend `label` (e.g. "10 GHS") when it is present. */
@Pipe({
  name: "appNote",
})
export class AppNotePipe implements PipeTransform {
  transform(value: number | undefined): unknown {
    switch (value as CurrencyNoteType) {
      case CurrencyNoteType.Currency500:
        return "500 XAF";
      case CurrencyNoteType.Currency1000:
        return "1000 XAF";
      case CurrencyNoteType.Currency2000:
        return "2000 XAF";
      case CurrencyNoteType.Currency5000:
        return "5000 XAF";
      case CurrencyNoteType.Currency10000:
        return "10000 XAF";
      case CurrencyNoteType.Ghs10:
        return "10 GHS";
      case CurrencyNoteType.Ghs20:
        return "20 GHS";
      case CurrencyNoteType.Ghs50:
        return "50 GHS";
      case CurrencyNoteType.Ghs100:
        return "100 GHS";
    }
    return "Unknown";
  }
}
